<template>
  <div>
    <h1>{{ pageTitle }}</h1>
    <b-breadcrumb :items="breadcrumbItems" />
  </div>
</template>

<script>
import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue'

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
  },
  data() {
    return {
      pageTitle: '',
    }
  },
  computed: {
    breadcrumbItems() {
      return [{ text: 'Home', href: '/' }, { text: this.pageTitle }]
    },
  },
}
</script>
